import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Jenum(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
 <Sides/>
 <Helmet>
 
  <title>Master the Art of Java Enum: A Beginner's Tutorial Guide by CodeExampler</title>
<meta name="description" content="Java enum tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and questions of all technology like java tutorial, Java tutorial,Java tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java enum,what is java enum,java enum values,java enum with values,java enum valueof,java enumeration,java enum example,java enum as string,java enum string,java enum to string,java enum in class,java enum class,java enum constructor,java enum methods,java enum with string values
,java enum type,java enum comparison,java enum to int,java enum int,java enum equals,java enum ordinal,java enum inheritance,java enum naming convention,enum in java, what is enum in java, enum class in java, enum with values in java, why enum is used in java, enum in java example, create enum in java, use of enum in java, define enum in java, enum with multiple values in java, how to use enum in java, class interface or enum expected error in java, how to create enum in java, enum keyword in java, enum data type in java, enum in java with example, enum type in java, enum in java 8, enum in switch case java, switch case with enum in java, using enum in java, how to get enum value in java, how to declare enum in java, how to define enum in java, how to convert string to enum in java, what is the use of enum in java, how to convert enum to string in java, how to set enum value in java, enum set in java, declare enum in java, enum example in java, enum with key value in java, java enum in switch, extend enum in java, can we extend enum in java, why we use enum in java, enum with constructor in java, iterate enum in java, enum example in java 8, example of enum in java, enum constructor in java, enum package in java, how to initialize enum in java, use enum in java, what is an enum in java, class enum or interface expected error in java, use enum in switch case java, can enum extends class in java, how to iterate enum in java, enum program in java
,java enum declaration,java enum key value,java enum tutorial " />
<link rel="canonical" href="https://www.codeexampler.com/java-enum" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1"> Enum in Java</h1>
<div className="first">
        <a href="/java-passing-argument">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-history">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    
<h2 className="mt-4 mh2">java Enum declares in java :</h2>

<p className="mt-4 para">Enumerator uses Enum keyword. This is a set of symbols identifying the level values that the type can have, enclosed by curly braces.<br/>
1, enum declares by use any name like Roll-no,weeks etc.<br/>
2, Literal values are limited to the symbolic names like emp1,emp2,emp3,etc.<br/>
</p>



<h2 className="headings">Enum Syntax in Java:</h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}
            <span className="qwerty-10">enum </span>
            <span className="qwerty-5">employee</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-9"> &nbsp; emp1 </span>
            <span className="qwerty-10">,</span>
            <span className="qwerty-9">emp2 </span>
            <span className="qwerty-10">,</span>
            <span className="qwerty-9">emp3 </span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"}
            {"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-Write a Program enum java example?</h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}
            <span className="qwerty-7">public </span>
            <span className="qwerty-5">class</span>
            <span className="qwerty-4"> A</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-7"> &nbsp; public </span>
            <span className="qwerty-10">enum </span>
            <span className="qwerty-9">Weeks </span>
            {"\n"}
            <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
            {"\n"}
            <span className="qwerty-9">&nbsp; &nbsp; &nbsp; Monday </span>
            <span className="qwerty-10">,</span>
            {"\n"}
            <span className="qwerty-9">&nbsp; &nbsp; &nbsp; Tuesday </span>
            <span className="qwerty-10">,</span>
            {"\n"}
            <span className="qwerty-9">&nbsp; &nbsp; &nbsp; Thursday </span>
            <span className="qwerty-10">,</span>
            {"\n"}
            <span className="qwerty-9">&nbsp; &nbsp; &nbsp; Saturday </span>
            <span className="qwerty-10">,</span>
            {"\n"}
            <span className="qwerty-9">&nbsp; &nbsp; &nbsp; Wednesday </span>
            {"\n"}
            <span className="qwerty-3">&nbsp; &nbsp; &#125; </span>
            {"\n"}
            {"\n"}

            <span className="qwerty-7">&nbsp;&nbsp;&nbsp;public </span>
            <span className="qwerty">static </span>
            <span className="qwerty-3">void </span>
            <span className="qwerty-8">main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-10">String</span>
            <span className="qwerty-1">[] </span>
            <span className="qwerty-9">args</span>
            <span className="qwerty-1">) </span>
            {"\n"}
            <span className="qwerty-3"> &nbsp;&nbsp; &#123; </span>
            {"\n"}
            <span className="qwerty-8">&nbsp;&nbsp; &nbsp; for</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-9">Weeks </span>
            <span className="qwerty-4">s</span>
            <span className="qwerty-8">:</span>
            <span className="qwerty-9"> Weeks</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-10">values</span>
            <span className="qwerty-1">())</span>
            {"\n"}
            <span className="qwerty-10">&nbsp; &nbsp;&nbsp; &nbsp;System</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-10">out</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-10">println</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">s</span>
            <span className="qwerty-1">);</span>
            {"\n"}
            <span className="qwerty-3"> &nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>         

         
          </code>
        </pre>        
      </div>
      
      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"}
            <span className="qwerty-9">&nbsp; Monday </span>
            {"\n"}
            <span className="qwerty-9">&nbsp; Tuesday </span>
            {"\n"}
            <span className="qwerty-9">&nbsp; Thursday </span>
            {"\n"}
            <span className="qwerty-9">&nbsp; Saturday </span>
            {"\n"}
            <span className="qwerty-9">&nbsp; Wednesday </span>
            {"\n"}
              </code>{"\n"}{"   "}
              </pre>
        </div>
      </div>



<h2 className="headings">Q-Write a Program enum java example?</h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}
            <span className="qwerty-7">public </span>
            <span className="qwerty-5">class</span>
            <span className="qwerty-4"> A</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-7"> &nbsp; public </span>
            <span className="qwerty-10">enum </span>
            <span className="qwerty-9">Weeks </span>
            {"\n"}
            <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
            {"\n"}
            <span className="qwerty-9">&nbsp; &nbsp; &nbsp; Monday </span>
            <span className="qwerty-10">,</span>
            {"\n"}
            <span className="qwerty-9">&nbsp; &nbsp; &nbsp; Tuesday </span>
            <span className="qwerty-10">,</span>
            {"\n"}
            <span className="qwerty-9">&nbsp; &nbsp; &nbsp; Thursday </span>
            <span className="qwerty-10">,</span>
            {"\n"}
            <span className="qwerty-9">&nbsp; &nbsp; &nbsp; Saturday </span>
            <span className="qwerty-10">,</span>
            {"\n"}
            <span className="qwerty-9">&nbsp; &nbsp; &nbsp; Wednesday </span>
            {"\n"}
            <span className="qwerty-3">&nbsp; &nbsp; &#125; </span>
            {"\n"}
            {"\n"}

            <span className="qwerty-7">&nbsp;&nbsp;&nbsp;public </span>
            <span className="qwerty">static </span>
            <span className="qwerty-3">void </span>
            <span className="qwerty-8">main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-10">String</span>
            <span className="qwerty-1">[] </span>
            <span className="qwerty-9">args</span>
            <span className="qwerty-1">) </span>
            {"\n"}
            <span className="qwerty-3"> &nbsp;&nbsp; &#123; </span>
            {"\n"}            
            <span className="qwerty-9">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Weeks </span>
            <span className="qwerty-4">emp </span>
            <span className="qwerty-10">= </span>
            <span className="qwerty-9">Weeks</span>
            <span className="qwerty-10">.</span>
            <span className="qwerty-8">Monday;</span>

            {"\n"}
            <span className="qwerty-10">&nbsp; &nbsp;&nbsp; &nbsp;System</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-10">out</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-10">println</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">emp</span>
            <span className="qwerty-1">);</span>
            {"\n"}
            <span className="qwerty-3"> &nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>         

         
          </code>
        </pre>        
      </div>
      
      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"}
            <span className="qwerty-9">&nbsp; Monday </span>
              </code>{"\n"}{"   "}
              </pre>
        </div>
      </div>


<h2 className="mt-4 mh2">Create Two Object in Enum Java:
</h2>




<h2 className="headings">Q-Write a Program enum java example?</h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}
            <span className="qwerty-7">public </span>
            <span className="qwerty-5">class</span>
            <span className="qwerty-4"> A</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-7"> &nbsp; public </span>
            <span className="qwerty-10">enum </span>
            <span className="qwerty-9">Weeks </span>
            {"\n"}
            <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
            {"\n"}
            <span className="qwerty-9">&nbsp; &nbsp; &nbsp; Monday </span>
            <span className="qwerty-10">,</span>
            {"\n"}
            <span className="qwerty-9">&nbsp; &nbsp; &nbsp; Tuesday </span>
            <span className="qwerty-10">,</span>
            {"\n"}
            <span className="qwerty-9">&nbsp; &nbsp; &nbsp; Thursday </span>
            <span className="qwerty-10">,</span>
            {"\n"}
            <span className="qwerty-9">&nbsp; &nbsp; &nbsp; Saturday </span>
            <span className="qwerty-10">,</span>
            {"\n"}
            <span className="qwerty-9">&nbsp; &nbsp; &nbsp; Wednesday </span>
            {"\n"}
            <span className="qwerty-3">&nbsp; &nbsp; &#125; </span>
            {"\n"}
            {"\n"}

            <span className="qwerty-7">&nbsp;&nbsp;&nbsp;public </span>
            <span className="qwerty">static </span>
            <span className="qwerty-3">void </span>
            <span className="qwerty-8">main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-10">String</span>
            <span className="qwerty-1">[] </span>
            <span className="qwerty-9">args</span>
            <span className="qwerty-1">) </span>
            {"\n"}
            <span className="qwerty-3"> &nbsp;&nbsp; &#123; </span>
            {"\n"}            
            <span className="qwerty-9">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Weeks </span>
            <span className="qwerty-4">emp </span>
            <span className="qwerty-10">= </span>
            <span className="qwerty-9">Weeks</span>
            <span className="qwerty-10">.</span>
            <span className="qwerty-8">Monday;</span>
            {"\n"}            
            <span className="qwerty-9">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Weeks </span>
            <span className="qwerty-4">emp </span>
            <span className="qwerty-10">= </span>
            <span className="qwerty-9">Weeks</span>
            <span className="qwerty-10">.</span>
            <span className="qwerty-8">Thursday;</span>

            {"\n"}
            <span className="qwerty-10">&nbsp; &nbsp;&nbsp; &nbsp;System</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-10">out</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-10">println</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">emp1</span>
            <span className="qwerty-1">);</span>
            {"\n"}
            <span className="qwerty-10">&nbsp; &nbsp;&nbsp; &nbsp;System</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-10">out</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-10">println</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">emp2</span>
            <span className="qwerty-1">);</span>
            {"\n"}
            <span className="qwerty-3"> &nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>         
            {"\n"}{"\n"}
         
          </code>
        </pre>        
      </div>
      
      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"}
            <span className="qwerty-9">&nbsp; Monday </span>
            {"\n"}
            <span className="qwerty-9">&nbsp; Thursday</span>
              </code>{"\n"}{"   "}
              </pre>
        </div>
      </div>


  

  <h1 className="mt-5">  </h1>
    
  <div className="back">
        <a href="/java-passing-argument">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-history">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Jenum;